import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=1603003e&scoped=true&lang=pug&"
import script from "./Faq.vue?vue&type=script&lang=ts&"
export * from "./Faq.vue?vue&type=script&lang=ts&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=1603003e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603003e",
  null
  
)

export default component.exports